import React, { useEffect, useState } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml';
import { html as beautifyHtml } from 'js-beautify';

const ClubTermsEditModal = ({
  isOpen,
  onClose,
  htmlContent = '',
  onSave,
  title = 'Edit Club Terms',
  description = 'Add or edit the HTML content that will be shown to users when enabled.'
}) => {
  const [html, setHtml] = useState('');

  // Reset html state when modal opens to ensure cancelled changes don't persist
  useEffect(() => {
    if (isOpen && htmlContent) {
      setHtml(beautifyHtml(htmlContent, { indent_size: 2 }));
    } else if (!isOpen) {
      // Clear state when modal closes
      setHtml('');
    }
  }, [isOpen, htmlContent]);

  const handleSave = () => {
    const formatted = beautifyHtml(html, { indent_size: 2 });
    onSave(formatted);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-4xl rounded-lg shadow-xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
          <button
            onClick={onClose}
            className="text-slate-600 hover:text-slate-600 focus:outline-none"
            aria-label="Close editor"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="px-6 py-4 flex-1 flex flex-col min-h-0 overflow-hidden">
          <div className="mb-3 flex-shrink-0">
            <p className="text-sm text-slate-600">{description}</p>
          </div>
          <div className="flex-1 min-h-0 overflow-hidden">
            <CodeMirror
              value={html}
              options={{
                mode: 'xml',
                theme: 'default',
                lineNumbers: true,
              }}
              onBeforeChange={(editor, data, value) => setHtml(value)}
              className="h-full"
              style={{ height: '100%' }}
            />
          </div>
        </div>
        <div className="px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClubTermsEditModal;

